import { IconHP } from 'legacy/lut/assets/img/icons/IconHP'
import React from 'react'

interface IProps {
  className?: string
  small?: boolean
  onClick?: () => void
}

export const HPLogo = React.memo(({ className, onClick }: IProps) => {
  return (
    <div className={className || ''} onClick={onClick}>
      <IconHP width={40} height={40} />
    </div>
  )
})
